<div class="spinner" #animation></div>

<div class="wrap">
  <div class="spinner-css" data-cy="spinner"></div>
</div>
